export default "__VITE_ASSET__DPFWSGkn__"